import { useEffect } from "react";
import { createContext, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";

export const ActiveViewContext = createContext();

export const ActiveViewProvider = ({ children }) => {
  const location = useLocation();

  const params = useParams();

  const navigate = useNavigate();

  const [activeView, setActiveView] = useState(() => {
    if (typeof window !== "undefined") {
      const saved = sessionStorage.getItem("activeView");
      return saved ? JSON.parse(saved) : { loan: true, flexiSave: false };
    }
    return { loan: true, flexiSave: false };
  });

  useEffect(() => {
    sessionStorage.setItem("activeView", JSON.stringify(activeView));
  }, [activeView]);

  useEffect(() => {
    const pendingView = sessionStorage.getItem("pendingView");

    if (pendingView) {
      setActiveView((prev) => ({
        ...prev,
        loan: pendingView === "loan" ? !prev.loan : false,
        flexiSave: pendingView === "flexiSave" ? !prev.flexiSave : false,
      }));
      sessionStorage.removeItem("pendingView");
    }
  }, [location.pathname]);

  const handleActiveView = (id) => {
    const getPath = location.pathname.split("/")?.filter(Boolean);

    if (getPath.length > 1) {
      sessionStorage.setItem("pendingView", id);
      navigate(-1);
      return;
    } else if (getPath.length > 2) {
      sessionStorage.setItem("pendingView", id);
      navigate("/quotations");
      return;
    }

    if (getPath?.find((path) => path === "create-quotation")) {
      sessionStorage.setItem("pendingView", id);
      navigate(-1);
      return;
    }

    if (getPath.includes("accounts") && id === "loan") {
      sessionStorage.setItem("pendingView", id);
      navigate(-1);
      return;
    }

    setActiveView((prev) => ({
      ...prev,
      loan: id === "loan",
      flexiSave: id === "flexiSave",
    }));
  };

  return (
    <ActiveViewContext.Provider value={{ activeView, handleActiveView }}>
      {children}
    </ActiveViewContext.Provider>
  );
};

export const useActiveView = () => {
  return useContext(ActiveViewContext);
};
